'use strict';

var TreeGridAdapterFactory = function TreeGridAdapterFactory(TreeGridSettings) {
  return function (treeGridElem) {
    var treeGrid = treeGridElem;
    this.markRowAsEdited = function (id) {
      // Needed to trigger validation on the field.
      treeGrid.jqxTreeGrid('beginCellEdit', id, 'inputFilters');
      treeGrid.jqxTreeGrid('endCellEdit', id, 'inputFilters');
    };
    this.cancelEditing = function (id) {
      treeGrid.jqxTreeGrid('endCellEdit', id, 'inputFilters', true);
    };
    this.init = function (searchCriteriaBuilder) {
      var treeGridSettings = new TreeGridSettings(searchCriteriaBuilder);
      treeGrid.jqxTreeGrid(treeGridSettings);
    };
    this.getSelection = function () {
      return treeGrid ? treeGrid.jqxTreeGrid('getSelection') : [];
    };
    this.setSelection = function (id) {
      treeGrid.jqxTreeGrid('selectRow', id);
    };
    this.getTopLevelRows = function () {
      // It returns _only_ top level rows!
      return treeGrid.jqxTreeGrid('getRows');
    };
    this.expandRow = function (id) {
      treeGrid.jqxTreeGrid('expandRow', id);
    };
    this.expandAll = function () {
      var self = this;
      var rows = this.getTopLevelRows();
      var idColumn = this.getSourceId();
      var _traverseTree = function traverseTree(rows) {
        for (var i = 0; i < rows.length; i++) {
          if (rows[i].records) {
            var idValue = rows[i][idColumn];
            self.expandRow(idValue);
            _traverseTree(rows[i].records);
          }
        }
      };
      _traverseTree(rows);
    };
    this.getSourceId = function () {
      return treeGrid.jqxTreeGrid('source')._source.id;
    };
    this.sortByIndex = function () {
      treeGrid.jqxTreeGrid('sortBy', 'index', 'asc');
    };
    this.updateBoundData = function () {
      treeGrid.jqxTreeGrid('updateBoundData');
    };
  };
};
TreeGridAdapterFactory.$inject = ['TreeGridSettingsFactory'];
module.exports = TreeGridAdapterFactory;